import { Grid, GridProps } from '@mui/material'
import { ReactNode } from 'react'

interface Props extends GridProps {
  itl: ReactNode
  itr: ReactNode
}

const ModalTextSpacing = ({ itl, itr, ...props }: Props) => {
  return (
    <Grid container spacing={0} {...props} height="20px">
      <Grid item xs={7.5}>
        {itl}
      </Grid>
      <Grid item xs={4.5} textAlign="end">
        {itr}
      </Grid>
    </Grid>
  )
}
export default ModalTextSpacing
